
//
const addressLookup        = document.querySelector('.address-lookup');
const addressLookupResults = document.querySelector('.address-lookup .address-lookup-results');

if (addressLookup !== null && addressLookupResults !== null) {

    //
    const debounce      = require('../utils/debounce.js');
    const createElement = require('../utils/createElement.js');
    const emptyElement  = require('../utils/emptyElement.js');

    //
    document.querySelector('input[name="postcodeLookup"]').addEventListener('keydown', debounce(500, function(event) {

        //
        if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
            return true;
        }

        //
        let postcodeInput = document.querySelector('input[name="postcodeLookup"]');
        if (postcodeInput != null && postcodeInput.value.length >= 5) {
            findAddresses();
        }

    }));

    //
    function findAddresses(container) {

        //
        let postcodeInput = addressLookup.querySelector('input[name="postcodeLookup"]');
        if (postcodeInput == null || postcodeInput.value.length <= 3) {
            return false;
        }

        //
        const endpoint = 'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws';
        const params = {'Key' : addressLookup.dataset.key, 'Text' : postcodeInput.value, 'IsMiddleware' : false, 'Container' : ((typeof container == 'undefined') ? null : container), 'Origin' : '', 'Countries' : 'GBR', 'Limit' : 99, 'Language' : 'en-gb'}

        //
        return fetch(endpoint + '?' + new URLSearchParams(params).toString(), {'method' : 'GET'}).then((response) => response.json()).then((response) => {

            //
            let addresses = response.Items;

            //if we only got a single address, and it's not actually an address, search using that addresses id
            if (addresses.length == 1 && addresses[0].Type != 'Address') {
                findAddresses(addresses[0].Id);
            }

            //if we have one or more results, then show them to the user for them to make a selection on
            if (addresses.length > 1 || (addresses.length == 1 && addresses.Type == 'Address')) {

                //
                emptyElement(addressLookupResults);

                //
                addresses.forEach(address => {

                    //
                    const addressLookupResult = createElement('div', {
                        'data-id'          : address.Id,
                        'data-type'        : address.Type,
                        'data-text'        : address.Text,
                        'data-highlight'   : address.Highlight,
                        'data-description' : address.Description,
                    });

                    //
                    addressLookupResult.appendChild(document.createTextNode(address.Text + ' ' + address.Description));

                    //
                    addressLookupResults.appendChild(addressLookupResult);

                });

            }

        }).catch((error) => {
            console.error(error);
        });
    }

    //
    function retrieveAddress(container) {

        //
        const endpoint = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.0/json3.ws';
        const params = { 'Key' : addressLookup.dataset.key, 'Id' : container }

        //
        emptyElement(addressLookupResults);

        //
        return fetch(endpoint + '?' + new URLSearchParams(params).toString(), {'method' : 'GET'}).then((response) => response.json()).then((response) => {

            let address = response.Items[0];

            //get the first 3 lines of the address, allowing company name to bump line 3 away, and remove any empty elements
            let addressParts = [ address.Company, address.Line1, address.Line2, address.Line3, address.Line4, address.Line5 ].filter(function(part) {
                return part != null && part != '';
            }).splice(0, 3);

            //
            window[addressLookup.dataset.callback].call(undefined, {
                'line1'    : (addressParts[0] ?? null),
                'line2'    : (addressParts[1] ?? null),
                'line3'    : (addressParts[2] ?? null),
                'town'     : address.City,
                'county'   : address.Province,
                'country'  : address.CountryIso2,
                'postcode' : address.PostalCode,
            });

            //display the address fields, and hide the "search" box
            if (!addressLookup.dataset.nohide) {
               addressLookup.style.display = 'none';
            }

        }).catch((error) => {
            console.error(error);
        });

    }

    //add mouse functionality to the address result list
    addressLookupResults.addEventListener('mousedown', function(event) {
        if ((activeResult = addressLookupResults.querySelector('div.active')) !== null) {
            activeResult.classList.remove('active');
        }
        event.target.classList.add('active');
    });

    addressLookupResults.addEventListener('mouseup', function(event) {
        if ((activeResult = addressLookupResults.querySelector('div.active')) !== null && activeResult == event.target) {
            if (activeResult.dataset.type == 'Address') {
                retrieveAddress(activeResult.dataset.id);
            } else {
                findAddresses(activeResult.dataset.id);
            }
        }
    });

    //add keyboard functionality to the address result list
    addressLookup.addEventListener('keydown', function(event) {

        if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key) == false) {
            return true;
        }

        //
        event.preventDefault();

        //
        let activeResult = addressLookupResults.querySelector('.address-lookup-results div.active');
        let nextResult = null;

        if (event.key == 'ArrowUp') {

            //
            nextResult = ((activeResult !== null && activeResult.previousElementSibling !== null) ? activeResult.previousElementSibling : addressLookupResults.querySelector('div:last-child'));

            //no active result - make the first item active
            if (activeResult !== null) {
                activeResult.classList.remove('active')
            }

            //make the next item active (this is either the next reult or the first one.)
            nextResult.classList.add('active');

        }

        if (event.key == 'ArrowDown') {

            //
            nextResult = ((activeResult !== null && activeResult.nextElementSibling !== null) ? activeResult.nextElementSibling : addressLookupResults.querySelector('div:first-child'));

            //no active result - make the first item active
            if (activeResult !== null) {
                activeResult.classList.remove('active')
            }

            //make the next item active (this is either the next reult or the first one.)
            nextResult.classList.add('active');

        }

        //
        if (nextResult !== null) {
            addressLookupResults.scrollTop = nextResult.offsetTop - (nextResult.offsetHeight * 2);
        }

        //
        if (event.key == 'Enter') {
            if (activeResult.dataset.type == 'Address') {
                retrieveAddress(activeResult.dataset.id);
            } else {
                findAddresses(activeResult.dataset.id);
            }
        }

    });

}